import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ReferralApplicationAPI } from "./referral.api";

export const useReferralApplicationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ReferralApplicationAPI,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["applications"] });
      queryClient.invalidateQueries({ queryKey: ["referral-applications"] });
      queryClient.invalidateQueries({
        queryKey: ["applications", "detail", variables.application],
      });
      queryClient.invalidateQueries({ queryKey: ["auth", "admin-detail"] });
    },
  });
};
